// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles */
.MileageAnalysisTab_bus_analysis_header__7zg-3 {
  color: #364e69;
}

.MileageAnalysisTab_bus_selected_header__-Agxd {
  color: #364e69;
}

/* Download Button */
.MileageAnalysisTab_bus_download_button__Sesju {
  color: #83a4cf;
  background-color: transparent;
  border: none;
}

/* Tabs Container */
.MileageAnalysisTab_bus_tabs_container__cHfh1 {
  background-color: #e9ecef;
}

.MileageAnalysisTab_bus_tabs_wrapper__NNeqm {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.MileageAnalysisTab_bus_tabs_wrapper__NNeqm::-webkit-scrollbar {
  display: none;
}

/* Tab Item */
.MileageAnalysisTab_bus_tab_item__9F0Xi {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: all 0.2s ease;
  font-size: 14px;
  padding-bottom: 8px;
}

.MileageAnalysisTab_bus_tab_item_active__MYUJy {
  color: #83a4cf;
  border-bottom: 2px solid #83a4cf;
}

.MileageAnalysisTab_bus_tab_item_inactive__FdXiW {
  color: #6c757d;
}

/* Progress Bar */
.MileageAnalysisTab_bus_progress_container__es5Rp {
  height: 8px;
  background-color: #ced4da;
}

.MileageAnalysisTab_bus_progress_bar__8sKdg {
  background-color: #6c757d;
  transition: width 0.3s ease;
}

/* Benchmark Tabs */
.MileageAnalysisTab_bus_benchmark_tab__m1zSH {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_benchmark_tab_active__h6\\+Rb {
  color: #83a4cf;
  border-bottom: 2px solid #83a4cf;
}

.MileageAnalysisTab_bus_benchmark_tab_inactive__qlfw5 {
  color: #6c757d;
}

/* Chart Icon */
.MileageAnalysisTab_bus_chart_icon__YSjkH {
  color: #364e69;
}

/* Filter Summary */
.MileageAnalysisTab_bus_filter_summary__ahahl {
  color: #6c757d;
}

/* Section Container */
.MileageAnalysisTab_bus_section_container__o39XR {
  background-color: white;
  border: 1px solid #e9ecef;
  min-height: 300px;
  scroll-margin-top: 20px;
}

/* Section Header */
.MileageAnalysisTab_bus_section_header__JjhuZ {
  padding-bottom: 8px;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_section_header_active__4ovBu {
  color: #83a4cf;
  border-bottom: 2px solid #83a4cf;
}

.MileageAnalysisTab_bus_section_header_inactive__x-Pj4 {
  color: #364e69;
  border-bottom: 2px solid #e9ecef;
}

/* Special Sections */
.MileageAnalysisTab_bus_mileage_insights_container__ukVeP {
  background-color: white;
  border: 1px solid #e9ecef;
  scroll-margin-top: 20px;
}

.MileageAnalysisTab_bus_waterfall_chart_container__yHND- {
  background-color: white;
  border: 1px solid #e9ecef;
  scroll-margin-top: 20px;
}

/* Content Placeholder */
.MileageAnalysisTab_bus_content_placeholder__xW1LR {
  color: #6c757d;
}

/* Vehicle Container */
.MileageAnalysisTab_bus_vehicleContainer__kulI4 {
  height: 120px;
  gap: 15px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
}

/* Vehicle Details Section */
.MileageAnalysisTab_bus_vehicleDetailsSection__wGE9u {
  background-color: white;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
}

.MileageAnalysisTab_bus_vehicleDetailsTitle__s9\\+eu {
  color: #364e69;
  font-weight: 600;
  font-size: 14px;
}

/* Add Vehicle Slot Styles */
.MileageAnalysisTab_bus_addVehicleSlot__VAvc4 {
  background-color: #cddaea;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.MileageAnalysisTab_bus_addVehicleSlot__VAvc4:hover {
  background-color: #a3c2e8;
}

/* Selected Vehicle Slot */
.MileageAnalysisTab_bus_selectedVehicleSlot__V-gEY {
  background-color: #f8f9fa;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
  cursor: pointer;
}

/* Add Vehicle Content */
.MileageAnalysisTab_bus_addVehicleContent__2pIZW {
  color: #364e69;
  font-size: 14px;
  font-weight: 600;
}

.MileageAnalysisTab_bus_addVehicleIcon__sCv22 {
  width: 20px;
  height: 20px;
  background-color: #83a4cf;
  border-radius: 50%;
}

/* Selected Vehicle Text */
.MileageAnalysisTab_bus_selectedVehicleText__I3BOO {
  font-size: 12px;
  color: #364e69;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
}

/* Best Day Section */
.MileageAnalysisTab_bus_bestDaySection__tXU4Q {
  background-color: #f8f9fa;
  border-radius: 4px;
  height: 100%;
}

.MileageAnalysisTab_bus_bestDayText__QutUu {
  font-style: italic;
  font-size: 12px;
}

/* Selected Vehicle Display */
.MileageAnalysisTab_bus_selectedVehicleDisplay__ScCEb {
  background-color: rgba(66, 133, 244, 0.1);
}

.MileageAnalysisTab_bus_selectedVehicleLabel__gdLMG {
  font-size: 12px;
  color: #333;
}

.MileageAnalysisTab_bus_clearButton__blfb\\+ {
  background-color: transparent;
  border: none;
}

/* Modal Styles */
.MileageAnalysisTab_bus_modalOverlay__FXnaM {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.MileageAnalysisTab_bus_modalContainer__HDdV\\+ {
  width: 500px;
  max-height: 600px;
  overflow: hidden;
}

.MileageAnalysisTab_bus_modalTitle__XQSks {
  color: #364e69;
  font-weight: 600;
}

.MileageAnalysisTab_bus_closeButton__rZ7oy {
  background-color: transparent;
  border: none;
}

/* Search Input */
.MileageAnalysisTab_bus_searchIcon__kPOIr {
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.MileageAnalysisTab_bus_searchInput__j38D3 {
  padding-left: 40px;
  font-size: 14px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

/* Vehicle List */
.MileageAnalysisTab_bus_vehicleList__a0g-M {
  max-height: 400px;
  overflow-y: auto;
  min-height: 300px;
}

/* Empty State */
.MileageAnalysisTab_bus_emptyStateTitle__nebuH {
  font-size: 16px;
}

.MileageAnalysisTab_bus_emptyStateSubtitle__YC9so {
  font-size: 14px;
}

/* Vehicle Item Styles */
.MileageAnalysisTab_bus_vehicleItem__TvfYm {
  cursor: pointer;
  transition: all 0.2s;
  border-width: 1px;
}

.MileageAnalysisTab_bus_vehicleItem__TvfYm:hover {
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_vehicleItemSelected__yoHlS {
  border-width: 2px;
}

.MileageAnalysisTab_bus_vehicleName__v-AyH {
  font-size: 14px;
  font-weight: 600;
  color: #364e69;
}

.MileageAnalysisTab_bus_vehicleInfo__lJicR {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

/* Selected Indicator */
.MileageAnalysisTab_bus_selectedIndicator__v1goI {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.MileageAnalysisTab_bus_checkmark__DgPKH {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

/* Add Button Container */
.MileageAnalysisTab_bus_addButtonContainer__59CDq {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 15px;
}

.MileageAnalysisTab_bus_sectionTitle__y5v3q {
  color: #364e69;
  font-size: 14px;
}

/* Data card container styling */
.MileageAnalysisTab_bus_dataCard__pVOrh {
  background-color: #e9ecef;
  border-radius: 4px;
  height: 50px;
}

/* Data label styling */
.MileageAnalysisTab_bus_dataLabel__\\+sg9w {
  font-size: 13px;
  color: #666;
}

/* Data value styling */
.MileageAnalysisTab_bus_dataValue__eUCQP {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Header text styling */
.MileageAnalysisTab_bus_headerText__oLXIz {
  color: #364e69;
  font-size: 14px;
}

/* Label container styling */
.MileageAnalysisTab_bus_labelContainer__my-um {
  height: 40px;
}

/* Label text styling */
.MileageAnalysisTab_bus_labelText__rwB8t {
  font-size: 25px;
  color: #333;
  font-weight: 500;
}

/* Value container styling - shared for all value cells */
.MileageAnalysisTab_bus_valueContainer__hT\\+Sf {
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

/* Value text styling - shared for all value text */
.MileageAnalysisTab_bus_valueText__y14my {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Main container background */
.MileageAnalysisTab_bus_containerBackground__cIhsz {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Section Title */
.MileageAnalysisTab_bus_sectionTitle__y5v3q {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

/* Main Container */
.MileageAnalysisTab_bus_mainContainer__WQs0b {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Row Components */
.MileageAnalysisTab_bus_rowLabelContainer__9zi3Q {
  padding: 8px;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_rowLabel__whR-S {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_infoIcon__zNbiL {
  cursor: pointer;
}

.MileageAnalysisTab_bus_rowValueContainer__a5ojM {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
  cursor: default;
}

.MileageAnalysisTab_bus_clickableRow__VTSUM {
  cursor: pointer;
}

.MileageAnalysisTab_bus_rowValue__M9cu\\+ {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.MileageAnalysisTab_bus_clickableValue__xD1x8 {
  color: #83a4cf;
}

/* Chart Container */
.MileageAnalysisTab_bus_chartContainer__bXnwl {
  margin-top: 12px;
}

/* Summary Cards */
.MileageAnalysisTab_bus_summaryCard__2UO1e {
  padding: 12px;
  border-radius: 4px;
  background-color: #e8f0fe;
}

.MileageAnalysisTab_bus_summaryCardLabel__VCaEV {
  font-size: 11px;
  color: #5f6368;
  margin-bottom: 8px;
}

.MileageAnalysisTab_bus_currentValueText__XrYcq {
  font-size: 18px;
  font-weight: bold;
  color: #1a73e8;
  margin-right: 6px;
}

.MileageAnalysisTab_bus_bestValueText__\\+L3Z6 {
  font-size: 18px;
  font-weight: bold;
  color: #09a106;
  margin-right: 6px;
}

.MileageAnalysisTab_bus_positiveArrow__x\\+hgb {
  color: #34a853;
  font-size: 14px;
}

.MileageAnalysisTab_bus_negativeArrow__a8tjG {
  color: #ea4335;
  font-size: 14px;
}

/* Chart Area */
.MileageAnalysisTab_bus_chartArea__8Acih {
  position: relative;
  height: 350px;
  margin-top: 20px;
}

/* Y-axis */
.MileageAnalysisTab_bus_yAxisContainer__uLuT7 {
  position: absolute;
  left: 0;
  top: 20px;
  height: 260px;
  width: 40px;
}

.MileageAnalysisTab_bus_yAxisLabel__j\\+FxO {
  position: absolute;
  text-align: end;
  display: flex;
  align-items: center;
  justify-content: end;
  right: 5px;
  font-size: 11px;
  color: #5f6368;
  width: 30px;
  height: 20px;
}

/* Chart Grid */
.MileageAnalysisTab_bus_chartGrid__fQFPE {
  position: absolute;
  left: 45px;
  top: 20px;
  right: 0;
  height: 260px;
  border-left: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0;
}

.MileageAnalysisTab_bus_gridLine__cCCbe {
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #f0f0f0;
}

.MileageAnalysisTab_bus_bottomGridLine__e3iAJ {
  background-color: #e0e0e0;
}

/* Bars Container */
.MileageAnalysisTab_bus_barsContainer__UU3yp {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: end;
  bottom: 0;
  height: 260px;
  gap: 10px;
  padding: 0 10px;
}

.MileageAnalysisTab_bus_barColumn__g7Bnl {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  flex: 1 1;
  height: 100%;
  position: relative;
}

.MileageAnalysisTab_bus_barValueLabel__lTO9U {
  text-align: center;
  position: absolute;
  font-size: 11px;
  font-weight: 600;
  color: #333;
  width: 100%;
}

.MileageAnalysisTab_bus_bar__JMWET {
  width: 60%;
  max-width: 45px;
  border-radius: 3px 3px 0 0;
  transition: all 0.3s ease;
  align-self: center;
}

/* X-axis */
.MileageAnalysisTab_bus_xAxisContainer__lXYV0 {
  position: absolute;
  left: 45px;
  right: 0;
  top: 290px;
  display: flex;
  gap: 10px;
  padding: 0 10px;
}

.MileageAnalysisTab_bus_xAxisLabel__Dp3vA {
  flex: 1 1;
  text-align: center;
  font-size: 10px;
  color: #5f6368;
  font-weight: 500;
  line-height: 1.2;
}

/* Chart Footer */
.MileageAnalysisTab_bus_chartFooterNote__YlSwV {
  text-align: center;
  margin-top: 12px;
  font-size: 10px;
  color: #5f6368;
  font-style: italic;
}

/* Modal Styles */
.MileageAnalysisTab_bus_modalOverlay__FXnaM {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  animation: MileageAnalysisTab_bus_fadeIn__F\\+oDz 0.3s ease-in-out;
}

.MileageAnalysisTab_bus_modalContent__K7O5b {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 70%;
  max-width: 600px;
  min-width: 500px;
  max-height: 80vh;
  animation: MileageAnalysisTab_bus_slideIn__QvtSI 0.3s ease-out;
}

.MileageAnalysisTab_bus_tooltipModalContent__JyDw8 {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
  animation: MileageAnalysisTab_bus_slideIn__QvtSI 0.3s ease-out;
}

.MileageAnalysisTab_bus_modalHeader__0Amy6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_modalTitle__XQSks {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 16px;
}

.MileageAnalysisTab_bus_modalBody__FPEEm {
  padding: 16px;
  overflow-y: auto;
  max-height: calc(80vh - 80px);
}

/* Tooltip Table Styles */
.MileageAnalysisTab_bus_tooltipTableContainer__bMHyC {
  padding: 12px;
}

.MileageAnalysisTab_bus_tooltipTable__m4Von {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
  margin-bottom: 0;
}

.MileageAnalysisTab_bus_tooltipTableHeader__LnExg {
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr {
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #364e69;
  padding: 8px;
  border: 1px solid #dee2e6;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr:nth-child(1) {
  width: 15%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr:nth-child(2) {
  width: 35%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr:nth-child(3) {
  width: 25%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr:nth-child(4) {
  width: 25%;
}

.MileageAnalysisTab_bus_tooltipTableCell__SlLrw {
  text-align: center;
  font-size: 11px;
  padding: 8px;
  border: 1px solid #dee2e6;
}

.MileageAnalysisTab_bus_tooltipValueCell__aQhX- {
  color: #4285f4;
}

/* Animations */
@keyframes MileageAnalysisTab_bus_fadeIn__F\\+oDz {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes MileageAnalysisTab_bus_slideIn__QvtSI {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Label container styling */
.MileageAnalysisTab_bus_labelContainer__my-um {
  padding: 8px;
  display: flex;
  align-items: center;
  height: 40px;
}

/* Data container styling */
.MileageAnalysisTab_bus_dataContainer__8uxre {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

/* Card container styling */
.MileageAnalysisTab_bus_cardContainer__kQqzU {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Card title styling */
.MileageAnalysisTab_bus_cardTitle__g7DeP {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

/* Label text styling */
.MileageAnalysisTab_bus_labelText__rwB8t {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

/* Base data text styling */
.MileageAnalysisTab_bus_dataText__1LyOS {
  font-size: 13px;
  font-weight: 600;
}

/* Normal text color */
.MileageAnalysisTab_bus_normalText__A-l7t {
  color: #333;
}

/* Percentage text color */
.MileageAnalysisTab_bus_percentageText__rc8T3 {
  color: #4285f4;
}

/* Container styles */
.MileageAnalysisTab_bus_cardContainer__kQqzU {
  margin-bottom: 1rem;
}

.MileageAnalysisTab_bus_headerContainer__rRCKy {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}

.MileageAnalysisTab_bus_headerTitle__QwSD3 {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

.MileageAnalysisTab_bus_contentContainer__Qbh7G {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Row styles */
.MileageAnalysisTab_bus_rowContainer__s98aP {
  margin-bottom: 0.5rem;
}

.MileageAnalysisTab_bus_labelColumn__ch3AG {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_labelColumnWithToggle__dGINe {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 40px;
}

.MileageAnalysisTab_bus_labelText__rwB8t {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_labelTextWithToggle__w3VGO {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
}

.MileageAnalysisTab_bus_dataColumn__qmUbc {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

.MileageAnalysisTab_bus_dataText__1LyOS {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Toggle button styles */
.MileageAnalysisTab_bus_toggleContainer__lsIY9 {
  margin-top: 4px;
}

.MileageAnalysisTab_bus_toggleButton__txh4P {
  display: flex;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 15px;
  overflow: hidden;
  width: 90px;
  /* Increased to fit text */
  height: 24px;
  font-size: 10px;
  /* Smaller text */
  align-items: center;
  /* Vertically center text */
  justify-content: center;
  /* Horizontally center text */
  white-space: nowrap;
  /* Prevents wrapping */
}

.MileageAnalysisTab_bus_toggleOption__WGvl5 {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_toggleOptionActive__-cXJo {
  background-color: #83a4cf;
  color: white;
}

.MileageAnalysisTab_bus_toggleOptionInactive__Ipog3 {
  background-color: transparent;
  color: #666;
}

/* Header text styling */
.MileageAnalysisTab_bus_headerText__oLXIz {
  color: #364e69;
  font-size: 14px;
}

/* Content container styling */
.MileageAnalysisTab_bus_contentContainer__Qbh7G {
  background-color: #f8f9fa;
  border-radius: 4px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Success icon styling */
.MileageAnalysisTab_bus_successIcon__TNF9G {
  font-size: 24px;
  color: #28a745;
}

/* Message text styling */
.MileageAnalysisTab_bus_messageText__A01JY {
  font-size: 14px;
  font-style: italic;
}

/* Vehicle Parameters Card Styles */
.MileageAnalysisTab_bus_cardContainer__kQqzU {
  margin-bottom: 1.5rem;
}

.MileageAnalysisTab_bus_headerContainer__rRCKy {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.MileageAnalysisTab_bus_headerTitle__QwSD3 {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

.MileageAnalysisTab_bus_parametersContainer__rOP2j {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

.MileageAnalysisTab_bus_rowContainer__s98aP {
  margin-bottom: 0.5rem;
}

.MileageAnalysisTab_bus_labelCell__WDXSI {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_labelText__rwB8t {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_dataCell__XA9Ks {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

.MileageAnalysisTab_bus_dataText__1LyOS {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.MileageAnalysisTab_bus_placeholderContainer__-hRfk {
  padding: 0.75rem;
  text-align: center;
  background-color: white;
  border-radius: 4px;
  margin-top: 10px;
  border: 1px dashed #dee2e6;
}

.MileageAnalysisTab_bus_placeholderText__Tx50B {
  margin-bottom: 0;
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
}

/* Insights Card Styles */
.MileageAnalysisTab_bus_insightsCard__senP- {
  background-color: white;
  border: 1px solid #e9ecef;
}

.MileageAnalysisTab_bus_insightsHeader__Xtt4k {
  color: #364e69;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.MileageAnalysisTab_bus_insightsList__DwwpR {
  padding-left: 20px;
  text-align: left;
}

.MileageAnalysisTab_bus_insightItem__\\+N\\+mB {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

/* Header and text colors */
.MileageAnalysisTab_bus_headerText__oLXIz {
  color: #2c3e50;
}

.MileageAnalysisTab_bus_mutedText__kwEHy {
  color: #6c757d;
}

.MileageAnalysisTab_bus_brandColor__7ux4n {
  color: #83a4cf;
}

/* Toggle buttons */
.MileageAnalysisTab_bus_toggleButton__txh4P {
  border-radius: 15px 0 0 15px;
  font-size: 0.9rem;
}

.MileageAnalysisTab_bus_toggleButtonRight__Kc0Cb {
  border-radius: 0 15px 15px 0;
  font-size: 10px;
  /* Match the smaller size used in .toggleButton */
  display: flex;
  /* For centering content */
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.MileageAnalysisTab_bus_activeToggle__Ag7QR {
  background-color: #83a4cf;
}

.MileageAnalysisTab_bus_inactiveToggle__0NwMN {
  background-color: transparent;
}

/* Description section */
.MileageAnalysisTab_bus_descriptionSection__Mc\\+x3 {
  background-color: #f8f9fa;
}

/* Chart container */
.MileageAnalysisTab_bus_chartContainer__bXnwl {
  height: 400px;
  overflow-x: auto;
}

.MileageAnalysisTab_bus_chartSvg__LZzB\\+ {
  min-width: 800px;
}

/* Text sizes */
.MileageAnalysisTab_bus_valueText__y14my {
  font-size: 12px;
}

.MileageAnalysisTab_bus_labelText__rwB8t {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_totalText__Cqsi9 {
  font-size: 14px;
}

.MileageAnalysisTab_bus_actionButton__JApAN {
  background-color: transparent;
  /* or your default bg */
  transition: background-color 0.2s;
}

.MileageAnalysisTab_bus_actionButton__JApAN:hover {
  background-color: #83a4cf !important;
}

.MileageAnalysisTab_bus_infoBand__L7PAz {
  background-color: #83a4cf;
  border-radius: 6px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: fit-content;
  max-width: 100%;
}

.MileageAnalysisTab_bus_infoBand__L7PAz:hover {
  opacity: 0.9;
}

.MileageAnalysisTab_bus_infoBandText__Ta-RJ {
  color: white;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

.MileageAnalysisTab_bus_infoBandIcon__BelW7 {
  color: white;
  cursor: pointer;
  margin-left: 6px;
  flex-shrink: 0;
}

.MileageAnalysisTab_bus_infoBandIcon__BelW7:hover {
  opacity: 0.8;
}

.MileageAnalysisTab_bus_chartContainer__bXnwl {
  position: relative;
  padding-left: 40px;
  /* Increase as needed */
}

.MileageAnalysisTab_bus_doubleHeightCell__mCSYt {
  min-height: 60px;
  /* Adjust height as needed */
  display: flex;
  align-items: center;
}

.MileageAnalysisTab_bus_tallRowValueContainer__VAede {
  min-height: 60px;
  /* Height to match label + band combined */
  display: flex;
  align-items: center;
  justify-content: center;
}

.MileageAnalysisTab_bus_rowValueContainer__a5ojM {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 3px;
  /* Your existing styles */
}

/* Updated rowLabelContainer to contain both text and info band */
.MileageAnalysisTab_bus_rowLabelContainer__9zi3Q {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 8px 0;
  /* Vertical padding for the container */
}

.MileageAnalysisTab_bus_rowLabel__whR-S {
  margin-bottom: 2px;
  /* Small gap between main text and info band */
}

/* Info band positioned directly under the main text */
.MileageAnalysisTab_bus_infoBand__L7PAz {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 0;
  padding-left: 0;
  /* Align with the main text */
}

.MileageAnalysisTab_bus_infoBandText__Ta-RJ {
  font-size: 11px;
  color: white;
  /* Changed to white */
  line-height: 1.2;
  padding: 4px 12px;
  /* Increased padding for bigger width */
  border-radius: 15px;
  /* Rounded corners */
  text-align: center;
  /* Center aligned text */
  min-width: 80px;
  /* Minimum width for consistency */
  display: inline-block;
  /* Allows width and text-align to work properly */
}

.MileageAnalysisTab_bus_infoBandIcon__BelW7 {
  cursor: pointer;
  color: white;
}

/* Remove the separate info band row styling since we're not using it anymore */
.MileageAnalysisTab_bus_infoBandRow__Xwg0g {
  display: none;
}


.MileageAnalysisTab_bus_spanHeight__biU5x {
  height: 60px
}

.MileageAnalysisTab_bus_disabledTab__Kg1p5 {
  /* background-color: #f0f0f0 !important; */
  /* Fainter background */
  color: #999 !important;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.8;
}

.MileageAnalysisTab_bus_disabledTab__Kg1p5:hover {
  cursor: not-allowed;
  background-color: #e4e4e4;
}

.MileageAnalysisTab_bus_custom_popover_width__tdx4\\+ {
  width: 420px !important;
  max-width: none !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MileageAnalysisTab_bus/MileageAnalysisTab_bus.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,iEAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8DAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,8DAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;;AAGA;EACE;AACF;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B","sourcesContent":["/* Header Styles */\n.analysis_header {\n  color: #364e69;\n}\n\n.selected_header {\n  color: #364e69;\n}\n\n/* Download Button */\n.download_button {\n  color: #83a4cf;\n  background-color: transparent;\n  border: none;\n}\n\n/* Tabs Container */\n.tabs_container {\n  background-color: #e9ecef;\n}\n\n.tabs_wrapper {\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tabs_wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Tab Item */\n.tab_item {\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  padding-bottom: 8px;\n}\n\n.tab_item_active {\n  color: #83a4cf;\n  border-bottom: 2px solid #83a4cf;\n}\n\n.tab_item_inactive {\n  color: #6c757d;\n}\n\n/* Progress Bar */\n.progress_container {\n  height: 8px;\n  background-color: #ced4da;\n}\n\n.progress_bar {\n  background-color: #6c757d;\n  transition: width 0.3s ease;\n}\n\n/* Benchmark Tabs */\n.benchmark_tab {\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.benchmark_tab_active {\n  color: #83a4cf;\n  border-bottom: 2px solid #83a4cf;\n}\n\n.benchmark_tab_inactive {\n  color: #6c757d;\n}\n\n/* Chart Icon */\n.chart_icon {\n  color: #364e69;\n}\n\n/* Filter Summary */\n.filter_summary {\n  color: #6c757d;\n}\n\n/* Section Container */\n.section_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  min-height: 300px;\n  scroll-margin-top: 20px;\n}\n\n/* Section Header */\n.section_header {\n  padding-bottom: 8px;\n  transition: all 0.2s ease;\n}\n\n.section_header_active {\n  color: #83a4cf;\n  border-bottom: 2px solid #83a4cf;\n}\n\n.section_header_inactive {\n  color: #364e69;\n  border-bottom: 2px solid #e9ecef;\n}\n\n/* Special Sections */\n.mileage_insights_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  scroll-margin-top: 20px;\n}\n\n.waterfall_chart_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  scroll-margin-top: 20px;\n}\n\n/* Content Placeholder */\n.content_placeholder {\n  color: #6c757d;\n}\n\n/* Vehicle Container */\n.vehicleContainer {\n  height: 120px;\n  gap: 15px;\n  background-color: white;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n/* Vehicle Details Section */\n.vehicleDetailsSection {\n  background-color: white;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n}\n\n.vehicleDetailsTitle {\n  color: #364e69;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Add Vehicle Slot Styles */\n.addVehicleSlot {\n  background-color: #cddaea;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.addVehicleSlot:hover {\n  background-color: #a3c2e8;\n}\n\n/* Selected Vehicle Slot */\n.selectedVehicleSlot {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n  cursor: pointer;\n}\n\n/* Add Vehicle Content */\n.addVehicleContent {\n  color: #364e69;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.addVehicleIcon {\n  width: 20px;\n  height: 20px;\n  background-color: #83a4cf;\n  border-radius: 50%;\n}\n\n/* Selected Vehicle Text */\n.selectedVehicleText {\n  font-size: 12px;\n  color: #364e69;\n  font-weight: 600;\n  text-align: center;\n  word-break: break-word;\n}\n\n/* Best Day Section */\n.bestDaySection {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  height: 100%;\n}\n\n.bestDayText {\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Selected Vehicle Display */\n.selectedVehicleDisplay {\n  background-color: rgba(66, 133, 244, 0.1);\n}\n\n.selectedVehicleLabel {\n  font-size: 12px;\n  color: #333;\n}\n\n.clearButton {\n  background-color: transparent;\n  border: none;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.modalContainer {\n  width: 500px;\n  max-height: 600px;\n  overflow: hidden;\n}\n\n.modalTitle {\n  color: #364e69;\n  font-weight: 600;\n}\n\n.closeButton {\n  background-color: transparent;\n  border: none;\n}\n\n/* Search Input */\n.searchIcon {\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n}\n\n.searchInput {\n  padding-left: 40px;\n  font-size: 14px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n/* Vehicle List */\n.vehicleList {\n  max-height: 400px;\n  overflow-y: auto;\n  min-height: 300px;\n}\n\n/* Empty State */\n.emptyStateTitle {\n  font-size: 16px;\n}\n\n.emptyStateSubtitle {\n  font-size: 14px;\n}\n\n/* Vehicle Item Styles */\n.vehicleItem {\n  cursor: pointer;\n  transition: all 0.2s;\n  border-width: 1px;\n}\n\n.vehicleItem:hover {\n  background-color: #f8f9fa;\n}\n\n.vehicleItemSelected {\n  border-width: 2px;\n}\n\n.vehicleName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #364e69;\n}\n\n.vehicleInfo {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n/* Selected Indicator */\n.selectedIndicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #007bff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.checkmark {\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Add Button Container */\n.addButtonContainer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 15px;\n}\n\n.sectionTitle {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Data card container styling */\n.dataCard {\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 50px;\n}\n\n/* Data label styling */\n.dataLabel {\n  font-size: 13px;\n  color: #666;\n}\n\n/* Data value styling */\n.dataValue {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Header text styling */\n.headerText {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Label container styling */\n.labelContainer {\n  height: 40px;\n}\n\n/* Label text styling */\n.labelText {\n  font-size: 25px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Value container styling - shared for all value cells */\n.valueContainer {\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n/* Value text styling - shared for all value text */\n.valueText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Main container background */\n.containerBackground {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Section Title */\n.sectionTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Main Container */\n.mainContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Row Components */\n.rowLabelContainer {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.rowLabel {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.infoIcon {\n  cursor: pointer;\n}\n\n.rowValueContainer {\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n  cursor: default;\n}\n\n.clickableRow {\n  cursor: pointer;\n}\n\n.rowValue {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.clickableValue {\n  color: #83a4cf;\n}\n\n/* Chart Container */\n.chartContainer {\n  margin-top: 12px;\n}\n\n/* Summary Cards */\n.summaryCard {\n  padding: 12px;\n  border-radius: 4px;\n  background-color: #e8f0fe;\n}\n\n.summaryCardLabel {\n  font-size: 11px;\n  color: #5f6368;\n  margin-bottom: 8px;\n}\n\n.currentValueText {\n  font-size: 18px;\n  font-weight: bold;\n  color: #1a73e8;\n  margin-right: 6px;\n}\n\n.bestValueText {\n  font-size: 18px;\n  font-weight: bold;\n  color: #09a106;\n  margin-right: 6px;\n}\n\n.positiveArrow {\n  color: #34a853;\n  font-size: 14px;\n}\n\n.negativeArrow {\n  color: #ea4335;\n  font-size: 14px;\n}\n\n/* Chart Area */\n.chartArea {\n  position: relative;\n  height: 350px;\n  margin-top: 20px;\n}\n\n/* Y-axis */\n.yAxisContainer {\n  position: absolute;\n  left: 0;\n  top: 20px;\n  height: 260px;\n  width: 40px;\n}\n\n.yAxisLabel {\n  position: absolute;\n  text-align: end;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  right: 5px;\n  font-size: 11px;\n  color: #5f6368;\n  width: 30px;\n  height: 20px;\n}\n\n/* Chart Grid */\n.chartGrid {\n  position: absolute;\n  left: 45px;\n  top: 20px;\n  right: 0;\n  height: 260px;\n  border-left: 2px solid #e0e0e0;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.gridLine {\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: #f0f0f0;\n}\n\n.bottomGridLine {\n  background-color: #e0e0e0;\n}\n\n/* Bars Container */\n.barsContainer {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  align-items: end;\n  bottom: 0;\n  height: 260px;\n  gap: 10px;\n  padding: 0 10px;\n}\n\n.barColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  flex: 1;\n  height: 100%;\n  position: relative;\n}\n\n.barValueLabel {\n  text-align: center;\n  position: absolute;\n  font-size: 11px;\n  font-weight: 600;\n  color: #333;\n  width: 100%;\n}\n\n.bar {\n  width: 60%;\n  max-width: 45px;\n  border-radius: 3px 3px 0 0;\n  transition: all 0.3s ease;\n  align-self: center;\n}\n\n/* X-axis */\n.xAxisContainer {\n  position: absolute;\n  left: 45px;\n  right: 0;\n  top: 290px;\n  display: flex;\n  gap: 10px;\n  padding: 0 10px;\n}\n\n.xAxisLabel {\n  flex: 1;\n  text-align: center;\n  font-size: 10px;\n  color: #5f6368;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n/* Chart Footer */\n.chartFooterNote {\n  text-align: center;\n  margin-top: 12px;\n  font-size: 10px;\n  color: #5f6368;\n  font-style: italic;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.modalContent {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 70%;\n  max-width: 600px;\n  min-width: 500px;\n  max-height: 80vh;\n  animation: slideIn 0.3s ease-out;\n}\n\n.tooltipModalContent {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 500px;\n  animation: slideIn 0.3s ease-out;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: #f8f9fa;\n}\n\n.modalTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 16px;\n}\n\n.modalBody {\n  padding: 16px;\n  overflow-y: auto;\n  max-height: calc(80vh - 80px);\n}\n\n/* Tooltip Table Styles */\n.tooltipTableContainer {\n  padding: 12px;\n}\n\n.tooltipTable {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #dee2e6;\n  margin-bottom: 0;\n}\n\n.tooltipTableHeader {\n  background-color: #f8f9fa;\n}\n\n.tooltipTableHeaderCell {\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n  color: #364e69;\n  padding: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.tooltipTableHeaderCell:nth-child(1) {\n  width: 15%;\n}\n\n.tooltipTableHeaderCell:nth-child(2) {\n  width: 35%;\n}\n\n.tooltipTableHeaderCell:nth-child(3) {\n  width: 25%;\n}\n\n.tooltipTableHeaderCell:nth-child(4) {\n  width: 25%;\n}\n\n.tooltipTableCell {\n  text-align: center;\n  font-size: 11px;\n  padding: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.tooltipValueCell {\n  color: #4285f4;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Label container styling */\n.labelContainer {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n/* Data container styling */\n.dataContainer {\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n/* Card container styling */\n.cardContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Card title styling */\n.cardTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Label text styling */\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Base data text styling */\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Normal text color */\n.normalText {\n  color: #333;\n}\n\n/* Percentage text color */\n.percentageText {\n  color: #4285f4;\n}\n\n/* Container styles */\n.cardContainer {\n  margin-bottom: 1rem;\n}\n\n.headerContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.headerTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n.contentContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Row styles */\n.rowContainer {\n  margin-bottom: 0.5rem;\n}\n\n.labelColumn {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.labelColumnWithToggle {\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 40px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.labelTextWithToggle {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n  margin-bottom: 4px;\n  text-align: left;\n}\n\n.dataColumn {\n  padding: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Toggle button styles */\n.toggleContainer {\n  margin-top: 4px;\n}\n\n.toggleButton {\n  display: flex;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n  overflow: hidden;\n  width: 90px;\n  /* Increased to fit text */\n  height: 24px;\n  font-size: 10px;\n  /* Smaller text */\n  align-items: center;\n  /* Vertically center text */\n  justify-content: center;\n  /* Horizontally center text */\n  white-space: nowrap;\n  /* Prevents wrapping */\n}\n\n.toggleOption {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.toggleOptionActive {\n  background-color: #83a4cf;\n  color: white;\n}\n\n.toggleOptionInactive {\n  background-color: transparent;\n  color: #666;\n}\n\n/* Header text styling */\n.headerText {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Content container styling */\n.contentContainer {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Success icon styling */\n.successIcon {\n  font-size: 24px;\n  color: #28a745;\n}\n\n/* Message text styling */\n.messageText {\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Vehicle Parameters Card Styles */\n.cardContainer {\n  margin-bottom: 1.5rem;\n}\n\n.headerContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.headerTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n.parametersContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n.rowContainer {\n  margin-bottom: 0.5rem;\n}\n\n.labelCell {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.dataCell {\n  padding: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.placeholderContainer {\n  padding: 0.75rem;\n  text-align: center;\n  background-color: white;\n  border-radius: 4px;\n  margin-top: 10px;\n  border: 1px dashed #dee2e6;\n}\n\n.placeholderText {\n  margin-bottom: 0;\n  color: #6c757d;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Insights Card Styles */\n.insightsCard {\n  background-color: white;\n  border: 1px solid #e9ecef;\n}\n\n.insightsHeader {\n  color: #364e69;\n  border-bottom: 2px solid #e9ecef;\n  padding-bottom: 8px;\n}\n\n.insightsList {\n  padding-left: 20px;\n  text-align: left;\n}\n\n.insightItem {\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n}\n\n/* Header and text colors */\n.headerText {\n  color: #2c3e50;\n}\n\n.mutedText {\n  color: #6c757d;\n}\n\n.brandColor {\n  color: #83a4cf;\n}\n\n/* Toggle buttons */\n.toggleButton {\n  border-radius: 15px 0 0 15px;\n  font-size: 0.9rem;\n}\n\n.toggleButtonRight {\n  border-radius: 0 15px 15px 0;\n  font-size: 10px;\n  /* Match the smaller size used in .toggleButton */\n  display: flex;\n  /* For centering content */\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.activeToggle {\n  background-color: #83a4cf;\n}\n\n.inactiveToggle {\n  background-color: transparent;\n}\n\n/* Description section */\n.descriptionSection {\n  background-color: #f8f9fa;\n}\n\n/* Chart container */\n.chartContainer {\n  height: 400px;\n  overflow-x: auto;\n}\n\n.chartSvg {\n  min-width: 800px;\n}\n\n/* Text sizes */\n.valueText {\n  font-size: 12px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.totalText {\n  font-size: 14px;\n}\n\n.actionButton {\n  background-color: transparent;\n  /* or your default bg */\n  transition: background-color 0.2s;\n}\n\n.actionButton:hover {\n  background-color: #83a4cf !important;\n}\n\n.infoBand {\n  background-color: #83a4cf;\n  border-radius: 6px;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.infoBand:hover {\n  opacity: 0.9;\n}\n\n.infoBandText {\n  color: white;\n  font-size: 10px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.infoBandIcon {\n  color: white;\n  cursor: pointer;\n  margin-left: 6px;\n  flex-shrink: 0;\n}\n\n.infoBandIcon:hover {\n  opacity: 0.8;\n}\n\n.chartContainer {\n  position: relative;\n  padding-left: 40px;\n  /* Increase as needed */\n}\n\n.doubleHeightCell {\n  min-height: 60px;\n  /* Adjust height as needed */\n  display: flex;\n  align-items: center;\n}\n\n.tallRowValueContainer {\n  min-height: 60px;\n  /* Height to match label + band combined */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rowValueContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1px 3px;\n  /* Your existing styles */\n}\n\n/* Updated rowLabelContainer to contain both text and info band */\n.rowLabelContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  padding: 8px 0;\n  /* Vertical padding for the container */\n}\n\n.rowLabel {\n  margin-bottom: 2px;\n  /* Small gap between main text and info band */\n}\n\n/* Info band positioned directly under the main text */\n.infoBand {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 0;\n  padding-left: 0;\n  /* Align with the main text */\n}\n\n.infoBandText {\n  font-size: 11px;\n  color: white;\n  /* Changed to white */\n  line-height: 1.2;\n  padding: 4px 12px;\n  /* Increased padding for bigger width */\n  border-radius: 15px;\n  /* Rounded corners */\n  text-align: center;\n  /* Center aligned text */\n  min-width: 80px;\n  /* Minimum width for consistency */\n  display: inline-block;\n  /* Allows width and text-align to work properly */\n}\n\n.infoBandIcon {\n  cursor: pointer;\n  color: white;\n}\n\n/* Remove the separate info band row styling since we're not using it anymore */\n.infoBandRow {\n  display: none;\n}\n\n\n.spanHeight {\n  height: 60px\n}\n\n.disabledTab {\n  /* background-color: #f0f0f0 !important; */\n  /* Fainter background */\n  color: #999 !important;\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.disabledTab:hover {\n  cursor: not-allowed;\n  background-color: #e4e4e4;\n}\n\n.custom_popover_width {\n  width: 420px !important;\n  max-width: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"analysis_header": `MileageAnalysisTab_bus_analysis_header__7zg-3`,
	"selected_header": `MileageAnalysisTab_bus_selected_header__-Agxd`,
	"download_button": `MileageAnalysisTab_bus_download_button__Sesju`,
	"tabs_container": `MileageAnalysisTab_bus_tabs_container__cHfh1`,
	"tabs_wrapper": `MileageAnalysisTab_bus_tabs_wrapper__NNeqm`,
	"tab_item": `MileageAnalysisTab_bus_tab_item__9F0Xi`,
	"tab_item_active": `MileageAnalysisTab_bus_tab_item_active__MYUJy`,
	"tab_item_inactive": `MileageAnalysisTab_bus_tab_item_inactive__FdXiW`,
	"progress_container": `MileageAnalysisTab_bus_progress_container__es5Rp`,
	"progress_bar": `MileageAnalysisTab_bus_progress_bar__8sKdg`,
	"benchmark_tab": `MileageAnalysisTab_bus_benchmark_tab__m1zSH`,
	"benchmark_tab_active": `MileageAnalysisTab_bus_benchmark_tab_active__h6+Rb`,
	"benchmark_tab_inactive": `MileageAnalysisTab_bus_benchmark_tab_inactive__qlfw5`,
	"chart_icon": `MileageAnalysisTab_bus_chart_icon__YSjkH`,
	"filter_summary": `MileageAnalysisTab_bus_filter_summary__ahahl`,
	"section_container": `MileageAnalysisTab_bus_section_container__o39XR`,
	"section_header": `MileageAnalysisTab_bus_section_header__JjhuZ`,
	"section_header_active": `MileageAnalysisTab_bus_section_header_active__4ovBu`,
	"section_header_inactive": `MileageAnalysisTab_bus_section_header_inactive__x-Pj4`,
	"mileage_insights_container": `MileageAnalysisTab_bus_mileage_insights_container__ukVeP`,
	"waterfall_chart_container": `MileageAnalysisTab_bus_waterfall_chart_container__yHND-`,
	"content_placeholder": `MileageAnalysisTab_bus_content_placeholder__xW1LR`,
	"vehicleContainer": `MileageAnalysisTab_bus_vehicleContainer__kulI4`,
	"vehicleDetailsSection": `MileageAnalysisTab_bus_vehicleDetailsSection__wGE9u`,
	"vehicleDetailsTitle": `MileageAnalysisTab_bus_vehicleDetailsTitle__s9+eu`,
	"addVehicleSlot": `MileageAnalysisTab_bus_addVehicleSlot__VAvc4`,
	"selectedVehicleSlot": `MileageAnalysisTab_bus_selectedVehicleSlot__V-gEY`,
	"addVehicleContent": `MileageAnalysisTab_bus_addVehicleContent__2pIZW`,
	"addVehicleIcon": `MileageAnalysisTab_bus_addVehicleIcon__sCv22`,
	"selectedVehicleText": `MileageAnalysisTab_bus_selectedVehicleText__I3BOO`,
	"bestDaySection": `MileageAnalysisTab_bus_bestDaySection__tXU4Q`,
	"bestDayText": `MileageAnalysisTab_bus_bestDayText__QutUu`,
	"selectedVehicleDisplay": `MileageAnalysisTab_bus_selectedVehicleDisplay__ScCEb`,
	"selectedVehicleLabel": `MileageAnalysisTab_bus_selectedVehicleLabel__gdLMG`,
	"clearButton": `MileageAnalysisTab_bus_clearButton__blfb+`,
	"modalOverlay": `MileageAnalysisTab_bus_modalOverlay__FXnaM`,
	"modalContainer": `MileageAnalysisTab_bus_modalContainer__HDdV+`,
	"modalTitle": `MileageAnalysisTab_bus_modalTitle__XQSks`,
	"closeButton": `MileageAnalysisTab_bus_closeButton__rZ7oy`,
	"searchIcon": `MileageAnalysisTab_bus_searchIcon__kPOIr`,
	"searchInput": `MileageAnalysisTab_bus_searchInput__j38D3`,
	"vehicleList": `MileageAnalysisTab_bus_vehicleList__a0g-M`,
	"emptyStateTitle": `MileageAnalysisTab_bus_emptyStateTitle__nebuH`,
	"emptyStateSubtitle": `MileageAnalysisTab_bus_emptyStateSubtitle__YC9so`,
	"vehicleItem": `MileageAnalysisTab_bus_vehicleItem__TvfYm`,
	"vehicleItemSelected": `MileageAnalysisTab_bus_vehicleItemSelected__yoHlS`,
	"vehicleName": `MileageAnalysisTab_bus_vehicleName__v-AyH`,
	"vehicleInfo": `MileageAnalysisTab_bus_vehicleInfo__lJicR`,
	"selectedIndicator": `MileageAnalysisTab_bus_selectedIndicator__v1goI`,
	"checkmark": `MileageAnalysisTab_bus_checkmark__DgPKH`,
	"addButtonContainer": `MileageAnalysisTab_bus_addButtonContainer__59CDq`,
	"sectionTitle": `MileageAnalysisTab_bus_sectionTitle__y5v3q`,
	"dataCard": `MileageAnalysisTab_bus_dataCard__pVOrh`,
	"dataLabel": `MileageAnalysisTab_bus_dataLabel__+sg9w`,
	"dataValue": `MileageAnalysisTab_bus_dataValue__eUCQP`,
	"headerText": `MileageAnalysisTab_bus_headerText__oLXIz`,
	"labelContainer": `MileageAnalysisTab_bus_labelContainer__my-um`,
	"labelText": `MileageAnalysisTab_bus_labelText__rwB8t`,
	"valueContainer": `MileageAnalysisTab_bus_valueContainer__hT+Sf`,
	"valueText": `MileageAnalysisTab_bus_valueText__y14my`,
	"containerBackground": `MileageAnalysisTab_bus_containerBackground__cIhsz`,
	"mainContainer": `MileageAnalysisTab_bus_mainContainer__WQs0b`,
	"rowLabelContainer": `MileageAnalysisTab_bus_rowLabelContainer__9zi3Q`,
	"rowLabel": `MileageAnalysisTab_bus_rowLabel__whR-S`,
	"infoIcon": `MileageAnalysisTab_bus_infoIcon__zNbiL`,
	"rowValueContainer": `MileageAnalysisTab_bus_rowValueContainer__a5ojM`,
	"clickableRow": `MileageAnalysisTab_bus_clickableRow__VTSUM`,
	"rowValue": `MileageAnalysisTab_bus_rowValue__M9cu+`,
	"clickableValue": `MileageAnalysisTab_bus_clickableValue__xD1x8`,
	"chartContainer": `MileageAnalysisTab_bus_chartContainer__bXnwl`,
	"summaryCard": `MileageAnalysisTab_bus_summaryCard__2UO1e`,
	"summaryCardLabel": `MileageAnalysisTab_bus_summaryCardLabel__VCaEV`,
	"currentValueText": `MileageAnalysisTab_bus_currentValueText__XrYcq`,
	"bestValueText": `MileageAnalysisTab_bus_bestValueText__+L3Z6`,
	"positiveArrow": `MileageAnalysisTab_bus_positiveArrow__x+hgb`,
	"negativeArrow": `MileageAnalysisTab_bus_negativeArrow__a8tjG`,
	"chartArea": `MileageAnalysisTab_bus_chartArea__8Acih`,
	"yAxisContainer": `MileageAnalysisTab_bus_yAxisContainer__uLuT7`,
	"yAxisLabel": `MileageAnalysisTab_bus_yAxisLabel__j+FxO`,
	"chartGrid": `MileageAnalysisTab_bus_chartGrid__fQFPE`,
	"gridLine": `MileageAnalysisTab_bus_gridLine__cCCbe`,
	"bottomGridLine": `MileageAnalysisTab_bus_bottomGridLine__e3iAJ`,
	"barsContainer": `MileageAnalysisTab_bus_barsContainer__UU3yp`,
	"barColumn": `MileageAnalysisTab_bus_barColumn__g7Bnl`,
	"barValueLabel": `MileageAnalysisTab_bus_barValueLabel__lTO9U`,
	"bar": `MileageAnalysisTab_bus_bar__JMWET`,
	"xAxisContainer": `MileageAnalysisTab_bus_xAxisContainer__lXYV0`,
	"xAxisLabel": `MileageAnalysisTab_bus_xAxisLabel__Dp3vA`,
	"chartFooterNote": `MileageAnalysisTab_bus_chartFooterNote__YlSwV`,
	"fadeIn": `MileageAnalysisTab_bus_fadeIn__F+oDz`,
	"modalContent": `MileageAnalysisTab_bus_modalContent__K7O5b`,
	"slideIn": `MileageAnalysisTab_bus_slideIn__QvtSI`,
	"tooltipModalContent": `MileageAnalysisTab_bus_tooltipModalContent__JyDw8`,
	"modalHeader": `MileageAnalysisTab_bus_modalHeader__0Amy6`,
	"modalBody": `MileageAnalysisTab_bus_modalBody__FPEEm`,
	"tooltipTableContainer": `MileageAnalysisTab_bus_tooltipTableContainer__bMHyC`,
	"tooltipTable": `MileageAnalysisTab_bus_tooltipTable__m4Von`,
	"tooltipTableHeader": `MileageAnalysisTab_bus_tooltipTableHeader__LnExg`,
	"tooltipTableHeaderCell": `MileageAnalysisTab_bus_tooltipTableHeaderCell__nMNPr`,
	"tooltipTableCell": `MileageAnalysisTab_bus_tooltipTableCell__SlLrw`,
	"tooltipValueCell": `MileageAnalysisTab_bus_tooltipValueCell__aQhX-`,
	"dataContainer": `MileageAnalysisTab_bus_dataContainer__8uxre`,
	"cardContainer": `MileageAnalysisTab_bus_cardContainer__kQqzU`,
	"cardTitle": `MileageAnalysisTab_bus_cardTitle__g7DeP`,
	"dataText": `MileageAnalysisTab_bus_dataText__1LyOS`,
	"normalText": `MileageAnalysisTab_bus_normalText__A-l7t`,
	"percentageText": `MileageAnalysisTab_bus_percentageText__rc8T3`,
	"headerContainer": `MileageAnalysisTab_bus_headerContainer__rRCKy`,
	"headerTitle": `MileageAnalysisTab_bus_headerTitle__QwSD3`,
	"contentContainer": `MileageAnalysisTab_bus_contentContainer__Qbh7G`,
	"rowContainer": `MileageAnalysisTab_bus_rowContainer__s98aP`,
	"labelColumn": `MileageAnalysisTab_bus_labelColumn__ch3AG`,
	"labelColumnWithToggle": `MileageAnalysisTab_bus_labelColumnWithToggle__dGINe`,
	"labelTextWithToggle": `MileageAnalysisTab_bus_labelTextWithToggle__w3VGO`,
	"dataColumn": `MileageAnalysisTab_bus_dataColumn__qmUbc`,
	"toggleContainer": `MileageAnalysisTab_bus_toggleContainer__lsIY9`,
	"toggleButton": `MileageAnalysisTab_bus_toggleButton__txh4P`,
	"toggleOption": `MileageAnalysisTab_bus_toggleOption__WGvl5`,
	"toggleOptionActive": `MileageAnalysisTab_bus_toggleOptionActive__-cXJo`,
	"toggleOptionInactive": `MileageAnalysisTab_bus_toggleOptionInactive__Ipog3`,
	"successIcon": `MileageAnalysisTab_bus_successIcon__TNF9G`,
	"messageText": `MileageAnalysisTab_bus_messageText__A01JY`,
	"parametersContainer": `MileageAnalysisTab_bus_parametersContainer__rOP2j`,
	"labelCell": `MileageAnalysisTab_bus_labelCell__WDXSI`,
	"dataCell": `MileageAnalysisTab_bus_dataCell__XA9Ks`,
	"placeholderContainer": `MileageAnalysisTab_bus_placeholderContainer__-hRfk`,
	"placeholderText": `MileageAnalysisTab_bus_placeholderText__Tx50B`,
	"insightsCard": `MileageAnalysisTab_bus_insightsCard__senP-`,
	"insightsHeader": `MileageAnalysisTab_bus_insightsHeader__Xtt4k`,
	"insightsList": `MileageAnalysisTab_bus_insightsList__DwwpR`,
	"insightItem": `MileageAnalysisTab_bus_insightItem__+N+mB`,
	"mutedText": `MileageAnalysisTab_bus_mutedText__kwEHy`,
	"brandColor": `MileageAnalysisTab_bus_brandColor__7ux4n`,
	"toggleButtonRight": `MileageAnalysisTab_bus_toggleButtonRight__Kc0Cb`,
	"activeToggle": `MileageAnalysisTab_bus_activeToggle__Ag7QR`,
	"inactiveToggle": `MileageAnalysisTab_bus_inactiveToggle__0NwMN`,
	"descriptionSection": `MileageAnalysisTab_bus_descriptionSection__Mc+x3`,
	"chartSvg": `MileageAnalysisTab_bus_chartSvg__LZzB+`,
	"totalText": `MileageAnalysisTab_bus_totalText__Cqsi9`,
	"actionButton": `MileageAnalysisTab_bus_actionButton__JApAN`,
	"infoBand": `MileageAnalysisTab_bus_infoBand__L7PAz`,
	"infoBandText": `MileageAnalysisTab_bus_infoBandText__Ta-RJ`,
	"infoBandIcon": `MileageAnalysisTab_bus_infoBandIcon__BelW7`,
	"doubleHeightCell": `MileageAnalysisTab_bus_doubleHeightCell__mCSYt`,
	"tallRowValueContainer": `MileageAnalysisTab_bus_tallRowValueContainer__VAede`,
	"infoBandRow": `MileageAnalysisTab_bus_infoBandRow__Xwg0g`,
	"spanHeight": `MileageAnalysisTab_bus_spanHeight__biU5x`,
	"disabledTab": `MileageAnalysisTab_bus_disabledTab__Kg1p5`,
	"custom_popover_width": `MileageAnalysisTab_bus_custom_popover_width__tdx4+`
};
export default ___CSS_LOADER_EXPORT___;
